import { useCallback } from 'react';
import { setShowSubscriptionCodeField } from '../../redux/actions/billing';
import { getIsRegistering } from '../../redux/selectors/authProgress';
import { getDeviceAuthCode } from '../../redux/selectors/device-auth';
import { createActivateURL } from '../../utils/router';
import { clearSubscriptionCodeInfo } from '../../web-shared/redux/actions/shared-billing';
import useInAppNavigate from '../router/use-in-app-navigate';
import useAppStore from '../use-app-store';
import useActivateDevice from './use-activate-device';

/** KU
 *
 * Returns a handler, {@link handleStartDeviceActivation}, which starts the
 * device activation process. If a code already exists, this handler attempts to
 * activate the device associated with the code (via
 * {@link handleActivateDevice}). Otherwise, this handler simply redirects the
 * user to the device activation landing page (i.e., `/go/activate`).
 * */
export default function useStartDeviceActivation() {
  const { getState, dispatch } = useAppStore();

  const navigate = useInAppNavigate();
  const { handleActivateDevice } = useActivateDevice();

  const handleStartDeviceActivation = useCallback(() => {
    const state = getState();
    const code = getDeviceAuthCode(state);
    const isRegistering = getIsRegistering(state);
    const activateURL = createActivateURL(code);

    if (!isRegistering) {
      dispatch(clearSubscriptionCodeInfo());
    }

    if (code) {
      handleActivateDevice(code);
    } else {
      navigate(activateURL, { replace: true });
    }

    dispatch(setShowSubscriptionCodeField(false));
  }, []);

  return { handleStartDeviceActivation };
}
